import { type Signal } from "@angular/core";

import type { BaseFilterDefinition, FilterSelection, Predicate, FilterSelectionInput } from "@filter/filter.types";

export abstract class Filter<TSelection extends FilterSelection, TItem, TFilterDefinition extends BaseFilterDefinition = BaseFilterDefinition> {
    public readonly definition: TFilterDefinition = this.createDefinition();
    public abstract readonly isActive: Signal<boolean>;
    protected createDefinition(): TFilterDefinition {
        return {
            ...this.getDefinitionInfo(),
        } as TFilterDefinition;
    }
    protected abstract getDefinitionInfo(): BaseFilterDefinition;

    // The selection represents the current state of the filter.
    public abstract clear(): void;
    public abstract readonly selection: Signal<FilterSelection>;
    public abstract setSelection(value: FilterSelectionInput): void;

    // The predicates are used to determine if an item satisfies the filter criteria.
    protected abstract getPredicate(selection?: TSelection): Predicate<TItem> | null;
    public abstract predicate(): Predicate<TItem> | null;
}
